import { ruleImpl } from './rule-impl';
import { issueSeverity } from "./rule-catalog";
import { BRAND_COMPETITOR_MAX } from "./question-capabilities";
import { requiredRefusalLine } from "./refusal-copy";
import type { QuestionnaireRefusalParams } from "./operations";
import type { QuestionnaireValidationIssue } from "./index";

export const COMPETITOR_LIMIT_EXCEEDED = "competitor_limit_exceeded";

const capParams = (count: number): QuestionnaireRefusalParams => ({
  limit: BRAND_COMPETITOR_MAX,
  count,
  excess: count - BRAND_COMPETITOR_MAX,
});

/**
 * The competitor cap (the registry's `brandCompetitorMax`), its one owner for
 * every writer: a roster over it is a question to the user, never a cut. The
 * goal card's intake, PLAN's brand facts, the chat's `set_study_context` and
 * the editor's live check (over `competitorsAfterGridEdit`, the names its Save
 * sends) all ask it here, in the catalog's one line; PLAN returns every name
 * the user keeps.
 */
export function competitorCapIssues(
  competitors: ReadonlyArray<string>,
  path: string,
): Array<QuestionnaireValidationIssue> {
  const count = competitors.length;
  if (count <= BRAND_COMPETITOR_MAX) return [];
  const params = capParams(count);
  return [
    {
      path,
      code: COMPETITOR_LIMIT_EXCEEDED,
      message: requiredRefusalLine(COMPETITOR_LIMIT_EXCEEDED, params),
      severity: issueSeverity(COMPETITOR_LIMIT_EXCEEDED),
      params,
    },
  ];
}

// Each rule below is decided by the function named (wave H T3, move 11).
ruleImpl('competitor_limit_exceeded', competitorCapIssues);
